export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20amber%20and%20cream%20flowing%20shapes%2C%20minimal%20modern%20design%2C%20elegant%20atmosphere%2C%20clean%20geometric%20patterns%2C%20no%20text%20no%20people%2C%20smooth%20organic%20curves&width=1800&height=800&seq=cta-bg-cpp&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-800/90 to-primary-700/80"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备好体验真正的 CPP 了吗？
        </h2>
        <p className="text-sm text-background-50/80 mb-8 max-w-lg mx-auto">
          告别第三方风险版本，立即下载CPP官方正版App，畅享安全纯净的完整功能体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="px-8 py-3.5 text-sm font-semibold whitespace-nowrap rounded-full bg-background-50 text-primary-700 hover:bg-background-100 transition-all duration-300 shadow-lg"
          >
            <i className="ri-download-line mr-2"></i>
            立即下载
          </a>
          <a
            href="/about"
            className="px-8 py-3.5 text-sm font-semibold whitespace-nowrap rounded-full bg-transparent text-background-50 border border-background-50/30 hover:bg-background-50/10 transition-all duration-300"
          >
            了解更多
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}